class GlobalError {
	static openErrorModal(errorMessage, modalId) {
		import('../components/modal')
			.then((module) => {
				const modalModule = new module.Modal();
				const params = {
					defaultMessage: errorMessage
				}
				modalModule.openModal('modal-global-error', modalId, 'modal/global-error', params);
			})
			.catch((error) => {
				console.error("Error loading module:", error);
			});
	}
}

module.exports = GlobalError;